define("shared/utils/plans-data/feature-groups", ["exports", "@ember/template"], function (_exports, _template) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/template"eaimeta@70e063a35619d71f

  /**
   * @class featureGroupsUtil
   * @extends Utils
   */

  /**
   * Stores dataset on feature groups of plans service
   *
   * @method featureGroups
   * @param {Service} intl
   *
   * @returns {Array} Feature groups data of plans service
   */
  const featureGroups = intl => [{
    title: intl.t('plans.plan'),
    features: [{
      name: intl.t('plans.auto_publish_posts'),
      key: 'autoPublish',
      tooltip: intl.t('plans.tooltip_auto_publish_posts')
    }, {
      name: intl.t('plans.multi_profile'),
      key: 'multiProfileScheduling',
      tooltip: intl.t('plans.tooltip_multi_profile')
    }, {
      name: intl.t('plans.visual_planner'),
      key: 'visualPlanner',
      tooltip: intl.t('plans.tooltip_visual_planner')
    }, {
      name: intl.t('plans.saved_captions'),
      key: 'savedCaptions',
      tooltip: intl.t('plans.tooltip_saved_captions')
    }, {
      name: intl.t('plans.draft_posts'),
      key: 'draftPosts',
      tooltip: intl.t('plans.tooltip_draft_posts')
    }, {
      name: intl.t('plans.bttp'),
      key: 'bttp',
      tooltip: intl.t('plans.tooltip_bttp')
    }, {
      name: intl.t('shared_phrases.hashtag_suggestions'),
      key: 'hashtagSuggestions',
      tooltip: intl.t('plans.tooltip_hashtag_suggestions')
    }, {
      name: intl.t('plans.auto_hashtag_suggestions'),
      key: 'captionHashtags',
      tooltip: intl.t('plans.tooltip_auto_hashtag_suggestions')
    }, {
      name: intl.t('plans.tagging'),
      key: 'tagging',
      tooltip: intl.t('plans.tooltip_tagging')
    }, {
      name: intl.t('plans.multi_photo'),
      key: 'multiPhoto',
      tooltip: intl.t('plans.tooltip_multi_photo')
    }, {
      name: (0, _template.htmlSafe)(intl.t('plans.schedule_stories')),
      key: 'stories',
      tooltip: intl.t('plans.tooltip_stories')
    }, {
      name: intl.t('plans.facebook_reels'),
      key: 'facebookReels',
      tooltip: intl.t('plans.tooltip_fb_reels_scheduling')
    }, {
      name: intl.t('plans.youtube_shorts'),
      key: 'youtubeShorts',
      tooltip: intl.t('plans.tooltip_youtube_shorts')
    }, {
      name: intl.t('plans.ig_reels_scheduling'),
      key: 'igReelsScheduling',
      tooltip: intl.t('plans.tooltip_ig_reels_scheduling')
    }, {
      name: intl.t('shared_phrases.first_comment'),
      key: 'firstComment',
      tooltip: intl.t('plans.tooltip_first_comment')
    }, {
      name: intl.t('plans.product_tag'),
      key: 'igProductTagging',
      tooltip: intl.t('plans.tooltip_product_tag')
    }, {
      name: intl.t('plans.media_storage'),
      key: 'unlimitedMedia',
      tooltip: intl.t('plans.tooltip_media_storage')
    }]
  }, // AI Features
  {
    title: intl.t('plans.ai_features'),
    features: [{
      name: intl.t('plans.ai_caption_writer.caption_writer'),
      key: 'aiCaptionWriter',
      tooltip: intl.t('plans.tooltip_caption_writer')
    }, {
      name: intl.t('plans.ideas'),
      key: 'ideas',
      tooltip: intl.t('plans.tooltip_ideas')
    }]
  }, // Creator & Brand Collabs
  {
    title: intl.t('shared_words.partnerships'),
    features: [{
      name: intl.t('plans.join_database'),
      key: 'influencerOptIn',
      tooltip: intl.t('plans.tooltip_join_database')
    }, {
      name: intl.t('plans.search_campaign'),
      key: 'campaignBoard',
      tooltip: intl.t('plans.tooltip_search_campaigns')
    }, {
      name: intl.t('plans.media_kit'),
      key: 'createMediaKit',
      tooltip: intl.t('plans.tooltip_media_kit')
    }, {
      name: intl.t('plans.post_campaigns'),
      key: 'searchInfluencers',
      tooltip: intl.t('plans.tooltip_post_campaign')
    }, {
      name: intl.t('plans.search_creators'),
      key: 'searchInfluencers',
      tooltip: intl.t('plans.tooltip_search_creators')
    }]
  }, {
    title: intl.t('shared_words.linkinbio'),
    features: [{
      name: intl.t('plans.linkin_bio.buttons'),
      key: 'linkinbioButton',
      tooltip: intl.t('plans.tooltip_linkinbio_buttons')
    }, {
      name: intl.t('plans.linkin_bio.social_posts'),
      key: 'linkinbioLinkedSocialPosts',
      tooltip: intl.t('plans.tooltip_linkinbio_social_posts')
    }, {
      name: intl.t('plans.linkin_bio.social_posts_tt'),
      key: 'linkinbioTiktokPostSupport',
      tooltip: intl.t('plans.tooltip_linkinbio_social_posts_tt')
    }, {
      name: intl.t('plans.featured_media'),
      key: 'linkinbioFeaturedMedia',
      tooltip: intl.t('plans.tooltip_featured_media')
    }, {
      name: intl.t('plans.featured_banner'),
      key: 'linkinbioFeaturedBanner',
      tooltip: intl.t('plans.tooltip_featured_banner')
    }, {
      name: intl.t('plans.linkin_bio.mailchimp_connection'),
      key: 'linkinbioMailchimp',
      tooltip: intl.t('plans.tooltip_mailchimp')
    }, {
      name: intl.t('plans.linkin_bio.later_branding'),
      key: 'linkinbioBannerless',
      tooltip: intl.t('plans.tooltip_linkinbio_later_branding')
    }, {
      name: intl.t('plans.linkin_bio.customization'),
      key: 'linkinbioButtonColor',
      tooltip: intl.t('plans.tooltip_customization')
    }, {
      name: intl.t('plans.linkin_bio.google_analytics'),
      key: 'linkinbioGoogleAnalytics',
      tooltip: intl.t('plans.tooltip_linkinbio_google_analytics')
    }]
  }, {
    title: intl.t('plans.analytics'),
    features: [{
      name: intl.t('plans.ig_analytics'),
      key: 'exportAnalytics',
      tooltip: intl.t('plans.tooltip_ig_analytics')
    }, {
      name: intl.t('plans.ig_post_performance'),
      key: 'igPostPerformance',
      tooltip: intl.t('plans.tooltip_ig_post_performance')
    }, {
      name: intl.t('plans.ig_story_performance'),
      key: 'igStoryPerformance',
      tooltip: intl.t('plans.tooltip_ig_story_performance')
    }, {
      name: intl.t('plans.ig_reels_analytics'),
      key: 'igReelsAnalytics',
      tooltip: intl.t('plans.tooltip_ig_reels_analytics')
    }, {
      name: intl.t('plans.ig_audience_insight'),
      key: 'analyticsStandard',
      tooltip: intl.t('plans.tooltip_ig_audience_insight')
    }, {
      name: intl.t('plans.hashtag_analytics'),
      key: 'hashtagAnalytics',
      tooltip: intl.t('plans.tooltip_hashtag_analytics')
    }, {
      name: intl.t('plans.ig_performance_report'),
      key: 'analyticsReport',
      tooltip: intl.t('plans.tooltip_performance_report')
    }, {
      name: intl.t('plans.linkin_bio.analytics'),
      key: 'linkinbioAnalytics',
      tooltip: intl.t('plans.tooltip_linkinbio_analytics')
    }, {
      name: intl.t('plans.twitter_analytics'),
      key: 'twitterPinterestAnalytics',
      tooltip: intl.t('plans.tooltip_twitter_analytics')
    }, {
      name: intl.t('plans.pinterest_analytics'),
      key: 'twitterPinterestAnalytics',
      tooltip: intl.t('plans.tooltip_pinterest_analytics')
    }, {
      name: intl.t('plans.analytics_features.tiktok_analytics'),
      key: 'tiktokAnalyticsTime',
      tooltip: intl.t('plans.tooltip_tiktok_analytics')
    }, {
      name: intl.t('plans.analytics_features.tiktok_audience_insights'),
      key: 'tiktokAnalytics',
      tooltip: intl.t('plans.tooltip_tiktok_audience_insights')
    }, {
      name: intl.t('plans.analytics_features.tiktok_post_performance'),
      key: 'tiktokAnalytics',
      tooltip: intl.t('plans.tooltip_tiktok_post_performance')
    }, {
      name: intl.t('plans.analytics_features.facebook_page_analytics'),
      key: 'facebookAnalytics',
      tooltip: intl.t('plans.tooltip_fb_page_analytics')
    }, {
      name: intl.t('plans.analytics_features.facebook_audience_analytics'),
      key: 'facebookAnalytics',
      tooltip: intl.t('plans.tooltip_fb_audience_analytics')
    }]
  }, {
    title: intl.t('plans.collect_features'),
    features: [{
      name: intl.t('plans.canva_export'),
      key: 'canvaExport',
      tooltip: intl.t('plans.tooltip_canva_export')
    }, {
      name: intl.t('plans.media_editing'),
      key: 'mediaEditing',
      tooltip: intl.t('plans.tooltip_media_editing')
    }, {
      name: intl.t('plans.chrome_extension'),
      key: 'chromeExtension',
      tooltip: intl.t('plans.tooltip_chrome_extension')
    }, {
      name: intl.t('plans.stock_photo'),
      key: 'stockPhoto',
      tooltip: intl.t('plans.tooltip_stock_photo')
    }, {
      name: intl.t('shared_phrases.search_profile'),
      key: 'searchByProfile',
      tooltip: intl.t('plans.tooltip_search_profile')
    }, {
      name: intl.t('plans.search_repost'),
      key: 'searchByHashtag',
      tooltip: intl.t('plans.tooltip_search_regram')
    }, {
      name: intl.t('plans.tagged'),
      key: 'tags',
      tooltip: intl.t('plans.tooltip_tagged_media')
    }, {
      name: intl.t('plans.mentions'),
      key: 'mentionedMedia',
      tooltip: intl.t('plans.tooltip_mentioned_media')
    }, {
      name: intl.t('shared_words.contributors'),
      key: 'contributors',
      tooltip: intl.t('plans.tooltip_contributors')
    }]
  }, {
    title: intl.t('plans.engagement'),
    features: [{
      name: intl.t('plans.conversations_ig'),
      key: 'conversations',
      tooltip: intl.t('plans.tooltip_conversations_ig')
    }, {
      name: intl.t('plans.conversations_tiktok'),
      key: 'tiktokConversations',
      tooltip: intl.t('plans.tooltip_conversations_tiktok')
    }]
  }, {
    title: intl.t('plans.team_management'),
    features: [{
      name: intl.t('plans.unlimited_groups'),
      key: 'groups',
      tooltip: intl.t('plans.tooltip_unlimited_groups')
    }, {
      name: intl.t('plans.share_calendar'),
      key: 'shareCalendar',
      tooltip: intl.t('plans.tooltip_share_calendar')
    }, {
      name: intl.t('plans.calendar_notes'),
      key: 'calendarNotes',
      tooltip: intl.t('plans.tooltip_calendar_notes')
    }]
  }, {
    title: intl.t('plans.customer_support'),
    features: [{
      name: intl.t('plans.support_docs'),
      key: 'supportDocs',
      tooltip: intl.t('plans.tooltip_support_docs')
    }, {
      name: intl.t('plans.human_support'),
      key: 'supportEmail',
      tooltip: intl.t('plans.tooltip_support_email')
    }, {
      name: intl.t('plans.support_messaging'),
      key: 'supportMessaging',
      tooltip: intl.t('plans.tooltip_support_messaging')
    }]
  }];

  var _default = featureGroups;
  _exports.default = _default;
});